import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import Header from "./Header";
import './CollaborationForm.css';

const CollaborationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    collabType: "",
    message: "",
  });

  const [collabOptions, setCollabOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_SECRET_KEY}/api/viewtypeofcollaboration`)
      .then((res) => {
        // ✅ fix: nested array
        const options = res.data?.View_Type_of_collaboration?.[0] || [];
        setCollabOptions(options);
        console.log("Collab Options:", options);
      })
      .catch((err) => console.error("Error:", err));
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, collabType, message } = formData;
    if (!name || !email || !collabType || !message) {
      alert("Please fill all required fields.");
      return;
    }

    const payload = {
      Artist_Name: formData.name,
      Email: formData.email,
      Company_Organization: formData.company,
      Phoneno: formData.phone,
      Miscellaneous_ID: parseInt(formData.collabType),
      Collab_Details: formData.message,
    };

    try {
      await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/addcollabdetail`, payload);
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        company: "",
        phone: "",
        collabType: "",
        message: "",
      });
    } catch (err) {
      console.error("Submit Error:", err);
      alert("Failed to submit form. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <Box className="collabform-wrapper">
        <Paper elevation={3} className="collabform-container">
          <Typography variant="h5" align="center" fontWeight="bold" className="title-collab">
            DM for Collaboration
          </Typography>
          <form onSubmit={handleSubmit} className="collabform-form">
            <div className="collabform-row">
              <TextField
                label="Name *"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                required
                className="collabform-input"
              />
              <TextField
                label="Email *"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                required
                className="collabform-input"
              />
            </div>

            <div className="collabform-row">
              <TextField
                label="Company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                fullWidth
                className="collabform-input"
              />
              <TextField
                label="Phone No"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
                className="collabform-input"
              />
            </div>

            <FormControl fullWidth required className="collabform-select">
              <InputLabel>Type of Collaboration</InputLabel>
              <Select
                name="collabType"
                value={formData.collabType}
                onChange={handleChange}
                label="Type of Collaboration"
              >
                <MenuItem value="">Select</MenuItem>
                {collabOptions.map((option) => (
                  <MenuItem key={option.Miscellaneous_ID} value={option.Miscellaneous_ID}>
                    {option.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Introduction *"
              name="message"
              value={formData.message}
              onChange={handleChange}
              multiline
              rows={4}
              fullWidth
              required
              className="collabform-textarea"
            />

            <div className="collabform-submit-wrapper">
              <Button type="submit" variant="contained" color="primary" className="collabform-submit-btn">
                Submit
              </Button>
              {submitted && (
                <Typography mt={2} color="green">
                  Thank you! We'll get in touch soon.
                </Typography>
              )}
            </div>
          </form>
        </Paper>
      </Box>
    </>
  );
};

export default CollaborationForm;








